import styled from "styled-components";

export const WaveformIcon = () => (
  <svg width="97" height="12" viewBox="0 0 97 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      width="1.15981"
      height="2.31963"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 0.319824 4.14894)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="3.47944"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 2.22949 3.57938)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="8.1187"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 4.11963 1.26999)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="10.4383"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 6.02295 0.120773)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="8.1187"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 7.95215 1.29099)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="3.47944"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 9.89404 3.62062)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="10.4383"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 11.7715 0.151703)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="6.95889"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 13.707 1.90163)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="10.4383"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 15.604 0.172318)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="3.47944"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 17.5591 3.66185)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="8.1187"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 19.4492 1.35268)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="9.27852"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 21.3589 0.783112)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="8.1187"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 23.2812 1.37329)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="3.47944"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 25.2236 3.70309)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="10.4383"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 27.1006 0.234177)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="9.27852"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 29.0234 0.824265)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="8.1187"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 30.9463 1.41472)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="8.1187"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 32.8623 1.42484)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="9.27852"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 34.772 0.85527)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="8.1187"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 36.6948 1.44547)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="8.1187"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 38.6108 1.45576)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="8.1187"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 40.5269 1.46608)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="5.79907"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 42.4561 2.63612)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="5.79907"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 44.3726 2.64644)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="5.79907"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 46.2886 2.65674)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="5.79907"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 48.2046 2.66705)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="8.1187"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 50.1079 1.51744)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="5.79907"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 52.0371 2.68767)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="5.79907"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 53.9531 2.69798)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="5.79907"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 55.8691 2.7083)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="5.79907"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 57.7856 2.7186)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="3.47944"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 59.7148 3.8886)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="5.79907"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 61.6177 2.73921)"
      fill="#0286DC"
    />
    <rect
      width="1.15981"
      height="8.1187"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 63.521 1.58981)"
      fill="#C5C5D0"
    />
    <rect
      width="1.15981"
      height="8.1187"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 65.437 1.6001)"
      fill="#C5C5D0"
    />
    <rect
      width="1.15981"
      height="8.1187"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 67.3535 1.6104)"
      fill="#C5C5D0"
    />
    <rect
      width="1.15981"
      height="5.79907"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 69.2827 2.78046)"
      fill="#C5C5D0"
    />
    <rect
      width="1.15981"
      height="5.79907"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 71.1987 2.79076)"
      fill="#C5C5D0"
    />
    <rect
      width="1.15981"
      height="5.79907"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 73.1147 2.80106)"
      fill="#C5C5D0"
    />
    <rect
      width="1.15981"
      height="3.47944"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 75.0439 3.97113)"
      fill="#C5C5D0"
    />
    <rect
      width="1.15981"
      height="8.1187"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 76.9341 1.66217)"
      fill="#C5C5D0"
    />
    <rect
      width="1.15981"
      height="9.27852"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 78.8438 1.09239)"
      fill="#C5C5D0"
    />
    <rect
      width="1.15981"
      height="8.1187"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 80.7666 1.68257)"
      fill="#C5C5D0"
    />
    <rect
      width="1.15981"
      height="3.47944"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 82.709 4.01231)"
      fill="#C5C5D0"
    />
    <rect
      width="1.15981"
      height="9.27852"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 84.5923 1.12308)"
      fill="#C5C5D0"
    />
    <rect
      width="1.15981"
      height="9.27852"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 86.5088 1.13362)"
      fill="#C5C5D0"
    />
    <rect
      width="1.15981"
      height="8.1187"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 88.4312 1.7238)"
      fill="#C5C5D0"
    />
    <rect
      width="1.15981"
      height="9.27852"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 90.3408 1.15424)"
      fill="#C5C5D0"
    />
    <rect
      width="1.15981"
      height="10.4383"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 92.2505 0.584671)"
      fill="#C5C5D0"
    />
    <rect
      width="1.15981"
      height="8.1187"
      rx="0.579907"
      transform="matrix(0.999986 0.00537994 0.0112004 0.999937 94.1797 1.75473)"
      fill="#C5C5D0"
    />
  </svg>
);

export const WaveformLongIcon = () => (
  <LongWaveWrapper>
    <WaveColored />
    <WaveGray />
  </LongWaveWrapper>
);

const LongWaveWrapper = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;
  width: 100%;

  div:first-of-type {
    width: 25%;
  }

  div:last-of-type {
    width: 75%;
  }
`;

const WaveColored = styled.div`
  height: 12px;
  background-image: url('data:image/svg+xml,%3Csvg width="100%25" height="12" xmlns="http://www.w3.org/2000/svg"%3E%3Cdefs%3E%3Cpattern id="bg" patternUnits="userSpaceOnUse" width="97" height="12"%3E%3Crect width="1.15981" height="2.31963" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 0.319824 4.14894)" fill="%230286DC" /%3E%3Crect width="1.15981" height="3.47944" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 2.22949 3.57938)" fill="%230286DC" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 4.11963 1.26999)" fill="%230286DC" /%3E%3Crect width="1.15981" height="10.4383" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 6.02295 0.120773)" fill="%230286DC" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 7.95215 1.29099)" fill="%230286DC" /%3E%3Crect width="1.15981" height="3.47944" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 9.89404 3.62062)" fill="%230286DC" /%3E%3Crect width="1.15981" height="10.4383" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 11.7715 0.151703)" fill="%230286DC" /%3E%3Crect width="1.15981" height="6.95889" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 13.707 1.90163)" fill="%230286DC" /%3E%3Crect width="1.15981" height="10.4383" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 15.604 0.172318)" fill="%230286DC" /%3E%3Crect width="1.15981" height="3.47944" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 17.5591 3.66185)" fill="%230286DC" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 19.4492 1.35268)" fill="%230286DC" /%3E%3Crect width="1.15981" height="9.27852" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 21.3589 0.783112)" fill="%230286DC" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 23.2812 1.37329)" fill="%230286DC" /%3E%3Crect width="1.15981" height="3.47944" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 25.2236 3.70309)" fill="%230286DC" /%3E%3Crect width="1.15981" height="10.4383" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 27.1006 0.234177)" fill="%230286DC" /%3E%3Crect width="1.15981" height="9.27852" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 29.0234 0.824265)" fill="%230286DC" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 30.9463 1.41472)" fill="%230286DC" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 32.8623 1.42484)" fill="%230286DC" /%3E%3Crect width="1.15981" height="9.27852" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 34.772 0.85527)" fill="%230286DC" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 36.6948 1.44547)" fill="%230286DC" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 38.6108 1.45576)" fill="%230286DC" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 40.5269 1.46608)" fill="%230286DC" /%3E%3Crect width="1.15981" height="5.79907" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 42.4561 2.63612)" fill="%230286DC" /%3E%3Crect width="1.15981" height="5.79907" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 44.3726 2.64644)" fill="%230286DC" /%3E%3Crect width="1.15981" height="5.79907" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 46.2886 2.65674)" fill="%230286DC" /%3E%3Crect width="1.15981" height="5.79907" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 48.2046 2.66705)" fill="%230286DC" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 50.1079 1.51744)" fill="%230286DC" /%3E%3Crect width="1.15981" height="5.79907" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 52.0371 2.68767)" fill="%230286DC" /%3E%3Crect width="1.15981" height="5.79907" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 53.9531 2.69798)" fill="%230286DC" /%3E%3Crect width="1.15981" height="5.79907" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 55.8691 2.7083)" fill="%230286DC" /%3E%3Crect width="1.15981" height="5.79907" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 57.7856 2.7186)" fill="%230286DC" /%3E%3Crect width="1.15981" height="3.47944" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 59.7148 3.8886)" fill="%230286DC" /%3E%3Crect width="1.15981" height="5.79907" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 61.6177 2.73921)" fill="%230286DC" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 63.521 1.58981)" fill="%230286DC" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 65.437 1.6001)" fill="%230286DC" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 67.3535 1.6104)" fill="%230286DC" /%3E%3Crect width="1.15981" height="5.79907" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 69.2827 2.78046)" fill="%230286DC" /%3E%3Crect width="1.15981" height="5.79907" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 71.1987 2.79076)" fill="%230286DC" /%3E%3Crect width="1.15981" height="5.79907" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 73.1147 2.80106)" fill="%230286DC" /%3E%3Crect width="1.15981" height="3.47944" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 75.0439 3.97113)" fill="%230286DC" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 76.9341 1.66217)" fill="%230286DC" /%3E%3Crect width="1.15981" height="9.27852" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 78.8438 1.09239)" fill="%230286DC" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 80.7666 1.68257)" fill="%230286DC" /%3E%3Crect width="1.15981" height="3.47944" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 82.709 4.01231)" fill="%230286DC" /%3E%3Crect width="1.15981" height="9.27852" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 84.5923 1.12308)" fill="%230286DC" /%3E%3Crect width="1.15981" height="9.27852" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 86.5088 1.13362)" fill="%230286DC" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 88.4312 1.7238)" fill="%230286DC" /%3E%3Crect width="1.15981" height="9.27852" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 90.3408 1.15424)" fill="%230286DC" /%3E%3Crect width="1.15981" height="10.4383" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 92.2505 0.584671)" fill="%230286DC" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 94.1797 1.75473)" fill="%230286DC" /%3E%3C/pattern%3E%3C/defs%3E%3Crect width="100%25" height="100%25" fill="url(%23bg)" /%3E%3C/svg%3E');
  background-size: 100% 12px;
  background-repeat: no-repeat;
`;

const WaveGray = styled.div`
  height: 12px;
  background-image: url('data:image/svg+xml,%3Csvg width="100%25" height="12" xmlns="http://www.w3.org/2000/svg"%3E%3Cdefs%3E%3Cpattern id="bg" patternUnits="userSpaceOnUse" width="97" height="12"%3E%3Crect width="1.15981" height="2.31963" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 0.319824 4.14894)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="3.47944" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 2.22949 3.57938)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 4.11963 1.26999)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="10.4383" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 6.02295 0.120773)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 7.95215 1.29099)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="3.47944" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 9.89404 3.62062)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="10.4383" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 11.7715 0.151703)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="6.95889" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 13.707 1.90163)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="10.4383" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 15.604 0.172318)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="3.47944" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 17.5591 3.66185)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 19.4492 1.35268)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="9.27852" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 21.3589 0.783112)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 23.2812 1.37329)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="3.47944" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 25.2236 3.70309)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="10.4383" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 27.1006 0.234177)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="9.27852" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 29.0234 0.824265)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 30.9463 1.41472)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 32.8623 1.42484)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="9.27852" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 34.772 0.85527)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 36.6948 1.44547)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 38.6108 1.45576)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 40.5269 1.46608)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="5.79907" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 42.4561 2.63612)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="5.79907" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 44.3726 2.64644)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="5.79907" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 46.2886 2.65674)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="5.79907" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 48.2046 2.66705)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 50.1079 1.51744)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="5.79907" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 52.0371 2.68767)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="5.79907" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 53.9531 2.69798)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="5.79907" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 55.8691 2.7083)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="5.79907" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 57.7856 2.7186)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="3.47944" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 59.7148 3.8886)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="5.79907" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 61.6177 2.73921)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 63.521 1.58981)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 65.437 1.6001)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 67.3535 1.6104)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="5.79907" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 69.2827 2.78046)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="5.79907" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 71.1987 2.79076)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="5.79907" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 73.1147 2.80106)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="3.47944" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 75.0439 3.97113)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 76.9341 1.66217)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="9.27852" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 78.8438 1.09239)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 80.7666 1.68257)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="3.47944" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 82.709 4.01231)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="9.27852" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 84.5923 1.12308)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="9.27852" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 86.5088 1.13362)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 88.4312 1.7238)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="9.27852" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 90.3408 1.15424)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="10.4383" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 92.2505 0.584671)" fill="%23C5C5D0" /%3E%3Crect width="1.15981" height="8.1187" rx="0.579907" transform="matrix(0.999986 0.00537994 0.0112004 0.999937 94.1797 1.75473)" fill="%23C5C5D0" /%3E%3C/pattern%3E%3C/defs%3E%3Crect width="100%25" height="100%25" fill="url(%23bg)" /%3E%3C/svg%3E');
  background-size: 100% 12px;
  background-repeat: no-repeat;
`;
